import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class RenderDoctors extends PureComponent {
    state = {
      isShowMore: false
    };

    _renderDoctors(id) {
      const doctors = this.props.doctors;
      const { isShowMore } = this.state;

      if (doctors.length === 0) {
        doctors.push('No doctors listed');
      }

      if (doctors.length > 5 && !isShowMore) {
        const slicedDoctors = doctors.slice(0, 5);

        return (<React.Fragment>
          <span>{slicedDoctors.join(', ')}</span>
          <span className={ 'rep-apts-index__doctors-button' } onClick={ this.handleShowDoctors(id) }>more</span>
        </React.Fragment>);
      }

      if (isShowMore) {
        return (<React.Fragment>
          <span>{doctors.join(', ')}</span>
          <span className={ 'rep-apts-index__doctors-button' } onClick={ this.handleShowDoctors(id) }>less</span>
        </React.Fragment>);
      }

      return doctors.join(', ');
    }

    handleShowDoctors = () => () => {
      const { isShowMore } = this.state;

      this.setState({ isShowMore: !isShowMore });
    };

    render() {
      return (
        this._renderDoctors()
      );
    }
}

RenderDoctors.propTypes = {
  doctors: PropTypes.instanceOf(Array).isRequired
};

export default RenderDoctors;



// WEBPACK FOOTER //
// ./app/components/reps/appointments/_RenderDoctors.jsx